const getWindow = () => (typeof window === "undefined" ? null : window);

const PERSONAL_DATA_KEYS = new Set([
  "company",
  "contact",
  "email",
  "message",
  "name",
  "phone",
  "problem",
  "telefone",
]);

const safeParams = (params = {}) =>
  Object.fromEntries(
    Object.entries(params).filter(([key]) => !PERSONAL_DATA_KEYS.has(key))
  );

const getTrafficSource = (windowRef) => {
  try {
    const stored = windowRef?.sessionStorage?.getItem("lead_source");
    if (!stored) return null;
    const parsed = JSON.parse(stored);
    return {
      traffic_source: parsed.source || "direct",
      traffic_medium: parsed.medium || "direct",
      traffic_campaign: parsed.campaign || "direct",
    };
  } catch {
    return null;
  }
};

const trackEvent = (eventName, params = {}, windowRef = getWindow()) => {
  if (!windowRef || typeof windowRef.gtag !== "function") return false;
  const contextParams = windowRef.location?.pathname
    ? {
        page_path: windowRef.location.pathname,
        ...(getTrafficSource(windowRef) || {
          traffic_source: "direct",
          traffic_medium: "direct",
          traffic_campaign: "direct",
        }),
      }
    : {};
  windowRef.gtag("event", eventName, { ...safeParams(params), ...contextParams });
  return true;
};

const trackWhatsappClick = (source, windowRef = getWindow()) =>
  trackEvent("whatsapp_click", { source }, windowRef);

const trackContactFormStart = (source, windowRef = getWindow()) =>
  trackEvent("contact_form_start", { source }, windowRef);

const trackContactFormSubmit = (source, windowRef = getWindow()) =>
  trackEvent("contact_form_submit", { source }, windowRef);

const trackDiagnosticStart = (source, windowRef = getWindow()) =>
  trackEvent("diagnostic_start", { source }, windowRef);

const trackDiagnosticComplete = (source, windowRef = getWindow()) =>
  trackEvent("diagnostic_complete", { source }, windowRef);

const trackCaseView = (caseId, windowRef = getWindow()) =>
  trackEvent("case_view", { case_id: caseId }, windowRef);

const trackPhoneClick = (source, windowRef = getWindow()) =>
  trackEvent("phone_click", { source }, windowRef);

const trackEmailClick = (source, windowRef = getWindow()) =>
  trackEvent("email_click", { source }, windowRef);

const trackBudgetRequest = (source, windowRef = getWindow()) =>
  trackEvent("budget_request", { source }, windowRef);

const trackTechPartnerClick = (source, windowRef = getWindow()) =>
  trackEvent("tech_partner_click", { source }, windowRef);

const trackServiceView = (servicePath, paramsOrWindow = {}, windowRef = getWindow()) => {
  const secondArgIsWindow = typeof paramsOrWindow?.gtag === "function";
  const params = secondArgIsWindow ? {} : paramsOrWindow;
  const targetWindow = secondArgIsWindow ? paramsOrWindow : windowRef;
  return trackEvent("service_view", { service_path: servicePath, ...params }, targetWindow);
};

const trackInsightView = (insightSlug, windowRef = getWindow()) =>
  trackEvent("insight_view", { insight_slug: insightSlug }, windowRef);

module.exports = {
  trackBudgetRequest,
  trackCaseView,
  trackContactFormStart,
  trackContactFormSubmit,
  trackDiagnosticComplete,
  trackDiagnosticStart,
  trackEmailClick,
  trackEvent,
  trackInsightView,
  trackPhoneClick,
  trackServiceView,
  trackTechPartnerClick,
  trackWhatsappClick,
};
